var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZetaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#005741"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1158 14.6525V16.2732H8.42997C8.5222 15.2066 8.86638 14.4561 10.0567 13.4008L15.1158 9.08481V12.8721H16.9369V5.9043H6.58142V9.37753H8.40257V7.72545H13.9041L8.86973 12.022L8.85768 12.0334C6.74781 13.9013 6.58008 15.4091 6.58008 17.1854V18.0957H16.9376V14.6539H15.1165L15.1158 14.6525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZetaLogo);
export default __webpack_public_path__ + "static/media/zeta-logo.5ee4dd815a8bb040c1b4000f95548b77.svg";
export { ForwardRef as ReactComponent };